import { dialogDefault, DIALOG_BILLNOTIFY } from "../consts";

const mydialog = {...dialogDefault}


export const billNotifyDialogAction = ({ open = false, id = 0, clientId = null  }) => ({
    type: DIALOG_BILLNOTIFY,
    payload : { open, id, clientId  }
});

export default function billNotifyDialogReducer(state = mydialog, { type, payload }) {

    const actions = {
        [DIALOG_BILLNOTIFY] : () => ({...state, ...payload })
    }

    return actions[type]?.call() || state;
}

